module.exports = __webpack_public_path__ + "static/media/Russell-Watkins.267af63f.jpg";